import { Button, Card, Form, InputNumber } from 'antd'
import { useWatch } from 'antd/es/form/Form'
import { BoosterProgramFormValues, BoosterRewardType } from 'Modules'

import { BOOSTER_PROGRAM_FIELD_MAX_LENGTH } from 'constants/booster-program'

import { MilestoneFieldsBlock } from './milestone-fields-block'
import { getThresholdRules } from './utils'

const MAX = BOOSTER_PROGRAM_FIELD_MAX_LENGTH

interface Props {
  index: number
  name: number
  onRemove: () => void
  canRemove: boolean
  removing?: boolean
}

export const MilestoneCard = ({ index, name, onRemove, canRemove, removing }: Props) => {
  const form = Form.useFormInstance<BoosterProgramFormValues>()
  const rewardType = useWatch(['milestones', name, 'rewardType'], form) as
    | BoosterRewardType
    | undefined

  return (
    <Card className="booster-program-create__milestone-card">
      <div className="booster-program-create__milestone-header">
        <div className="booster-program-create__milestone-heading">
          <span className="booster-program-create__milestone-label">M{index + 1} —</span>
          <span>Buy ≥</span>
          <Form.Item
            name={[name, 'threshold']}
            rules={getThresholdRules(
              index,
              () => form.getFieldValue(['milestones', index - 1, 'threshold']),
              () => form.getFieldValue(['milestones', index + 1, 'threshold'])
            )}
            style={{ marginBottom: 0 }}
          >
            <InputNumber
              min={1}
              maxLength={MAX.purchaseQuantity}
              placeholder="Input number"
              style={{ width: 100 }}
            />
          </Form.Item>
          <span className="booster-program-create__milestone-label">PTO (cumulative)</span>
        </div>
        {canRemove && (
          <Button
            type="link"
            onClick={onRemove}
            loading={removing}
            className="booster-program-create__milestone-remove"
          >
            Remove
          </Button>
        )}
      </div>

      <MilestoneFieldsBlock parentName={name} rewardType={rewardType} />
    </Card>
  )
}
